module.exports = __webpack_public_path__ + "img_balao2.png?9be974ebe1f833286b6911086dc1c5e8";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img_balao2.png
// module id = 5
// module chunks = 0